// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P7vI","content":"styles_content__2AR9E","tableWrap":"styles_tableWrap__hAia2"};